export const WINDOW_WIDTH = 1280;
export const WINDOW_WIDTH_MOBILE = 414;

export const parseUIPercents = input => {
  return (input / WINDOW_WIDTH) * 100 + "vw"
}

export const parseUIPercentsMobile = input => {
  return (input / WINDOW_WIDTH_MOBILE) * 100 + "vw"
}
